import { useEffect } from 'react';

let sanityVisualEditing: undefined | Promise<void | typeof import('./sanityVisualEditing')>;
export function lazyLoadVisualEditing() {
    sanityVisualEditing ??= import('./sanityVisualEditing').then((module) => module.enableOverlays());
}

export default function detectSanityPresentationMode(detected: () => void) {
    window.addEventListener('message', (e) => {
        if (!e.data || typeof e.data !== 'object') return;
        const { domain, from, to, type } = e.data;
        if (domain !== 'sanity/channels') return;
        if (from !== 'presentation') return;
        if (to !== 'overlays') return;
        if (type !== 'handshake/syn') return;
        detected();
    });
}

export function DraftModeLoader() {
    useEffect(() => {
        if (window.parent !== window) {
            lazyLoadVisualEditing();
        }
    }, []);

    return null;
}
